module.exports = __webpack_public_path__ + "static/law-justice-7fe978189705b98ef6a79d6e4139e5ad.jpg";